import React, { useState } from 'react';
import { View, ScrollView } from 'react-native';
import { TextInputMask } from 'react-native-masked-text';
import MaterialIcon from 'react-native-vector-icons/MaterialCommunityIcons';
import IonIcon from 'react-native-vector-icons/Ionicons';

import { useDispatch, useSelector } from 'react-redux';
import { AppHeader } from '../../../components/common';
import { AppText, AppSlider } from '../../../components/form';
import { pixelDimensions } from '../../../config/utils';
import styles from './styles';
import { GreenButton } from '../../../components/derivative';
import { WorkerActions } from '../../../redux/reducers/workerReducer';

const LevelOne = ({ navigation }) => {
  const { pnfamData } = useSelector((state) => state.worker);

  const dispatch = useDispatch();

  const [sliders, changeSliderValue] = useState({
    Cervical: 0,
    Lombar: 0,
    'Ombro E': 0,
    'Perna E': 0,
    'Punho E': 0,
    'Pé E': 0,
    'Centro Costas': 0,
    Peitoral: 0,
    'Ombro D': 0,
    'Perna D': 0,
    'Punho D': 0,
    'Pé D': 0,
  });
  const handleSliderChange = (title, value) => {
    changeSliderValue({
      ...sliders,
      [title]: value,
    });
  };
  const [levelOneParams, updateL1Params] = useState({
    weight: '',
    height: '',
  });

  const nextPage = () => {
    const data = {
      ...pnfamData,
      cervical: sliders.Cervical,
      centro_costas: sliders['Centro Costas'],
      lombar: sliders.Lombar,
      peitoral: sliders.Peitoral,
      ombro_esquerdo: sliders['Ombro E'],
      ombro_direito: sliders['Ombro D'],
      perna_esquerda: sliders['Perna E'],
      perna_direita: sliders['Perna D'],
      pe_esquerdo: sliders['Pé E'],
      pe_direito: sliders['Pé D'],
      perna_direito: sliders['Pé D'],
      punho_esquerdo: sliders['Punho E'],
      punho_direito: sliders['Punho D'],
    };
    dispatch({ type: WorkerActions.UPDATE_DATA, dataType: 'pnfamData', dataValue: { ...data } });
    navigation.navigate('Worker Level Two');
  };
  return (
    <View style={styles.viewBase}>
      <AppHeader title="Dor no Trabalho" hasBack navigation={navigation} />
      <View style={styles.content}>
        <ScrollView style={styles.scroll}>
          <View style={styles.viewL1Params}>
            <View style={styles.viewFields}>
              <TextInputMask value={levelOneParams.weight} type="custom" options={{ mask: '999,99' }} onChangeText={(weight) => updateL1Params({ ...levelOneParams, weight })} placeholder="Peso em KG" keyboardType="numeric" style={styles.input} />
              <MaterialIcon name="weight" style={styles.inputIcon} />
            </View>
            <View style={styles.viewFields}>
              <TextInputMask value={levelOneParams.height} type="custom" options={{ mask: '999,99' }} onChangeText={(height) => updateL1Params({ ...levelOneParams, height })} placeholder="Altura em CM" keyboardType="numeric" style={styles.input} />
              <MaterialIcon name="human-male-height" style={styles.inputIcon} />
            </View>
          </View>
          <AppText size="bold" style={styles.textClassify}>{'CLASSIFIQUE SEU NÍVEL DE DOR\nDURANTE O SEU TRABALHO'}</AppText>
          <View style={{ flexDirection: 'row' }}>
            <View>
              <AppSlider title="Cervical" value={`${sliders.Cervical} %`} changeValue={handleSliderChange} />
              <AppSlider title="Lombar" value={`${sliders.Lombar} %`} changeValue={handleSliderChange} />
              <AppSlider title="Ombro E" value={`${sliders['Ombro E']} %`} changeValue={handleSliderChange} />
              <AppSlider title="Perna E" value={`${sliders['Perna E']} %`} changeValue={handleSliderChange} />
              <AppSlider title="Punho E" value={`${sliders['Punho E']} %`} changeValue={handleSliderChange} />
              <AppSlider title="Pé E" value={`${sliders['Pé E']} %`} changeValue={handleSliderChange} />
            </View>
            <View>
              <AppSlider title="Centro Costas" value={`${sliders['Centro Costas']} %`} changeValue={handleSliderChange} />
              <AppSlider title="Peitoral" value={`${sliders.Peitoral} %`} changeValue={handleSliderChange} />
              <AppSlider title="Ombro D" value={`${sliders['Ombro D']} %`} changeValue={handleSliderChange} />
              <AppSlider title="Perna D" value={`${sliders['Perna D']} %`} changeValue={handleSliderChange} />
              <AppSlider title="Punho D" value={`${sliders['Punho D']} %`} changeValue={handleSliderChange} />
              <AppSlider title="Pé D" value={`${sliders['Pé D']} %`} changeValue={handleSliderChange} />
            </View>
          </View>
          <GreenButton
            onPress={() => nextPage()}
            label={(
              <AppText size="bold" style={styles.textButtonGreen}>
                AVANÇAR
                {' '}
                <IonIcon style={{ fontSize: pixelDimensions(5) }} name="chevron-forward" />
              </AppText>
)}
          />
        </ScrollView>
      </View>
    </View>
  );
};

export default LevelOne;
